import { CustomText } from "@root/components/common/components";
import { BetweenFlex, ColumnFlex } from "@root/components/dashboard/chat/style";
import { months } from "@root/webConstants";
import { useTranslation } from "react-i18next";
import { StatusViewer } from "../components";
import { dateConverter } from "@root/utils/dateHelper";
export const UserInfo = ({ user }: any) => {
  const { t } = useTranslation("common");
  const createdAt = new Date(user?.createdAt);

  const formatedCreatedAt = createdAt? dateConverter(user?.last_login, "YYYY/MM/DD HH:MM AM/PM"):" ";

  const lastLogin = user?.last_login ? new Date(user.last_login) : null;
  

  const formattedLastLogin = lastLogin
    ? dateConverter(user?.last_login, "YYYY/MM/DD HH:MM AM/PM")
    : "";

  return (
    <ColumnFlex
      p="16px"
      gap="16px"
      borderBottom="1px solid"
      borderColor="gray.100"
    >
      <CustomText
        text={t("userInfo.userInfo")}
        fontSize="16px"
        fontWeight={500}
      />
      <BetweenFlex>
        <CustomText text={t("userInfo.accountStatus")} />
        <StatusViewer status={user?.is_active} />
      </BetweenFlex>
      <BetweenFlex>
        <CustomText text={t("userInfo.id")} />
        <StatusViewer status={user?.id} />
      </BetweenFlex>
      <BetweenFlex>
        <CustomText text={t("userInfo.joinedCreated")} />
        <CustomText text={user?.createdAt ? formatedCreatedAt : ""} />
      </BetweenFlex>
      <BetweenFlex>
        <CustomText text={t("userInfo.lastLogin")} />
        <CustomText text={formattedLastLogin} />
      </BetweenFlex>
      <BetweenFlex>
        <CustomText text={t("userInfo.language")} />
        <CustomText
          text={
            user?.language === "en"
              ? t("language.english")
              : t("language.korean")
          }
        />
      </BetweenFlex>
    </ColumnFlex>
  );
};
